<template>
  <b-loading :is-full-page="isFullPage" :active.sync="isLoading" />
</template>

<script>
import { Toast } from "buefy/src/components/toast";
import BLoading from "buefy/src/components/loading/Loading";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { BLoading },
  data() {
    return {
      isLoading: true,
      isFullPage: true
    };
  },

  created() {
    Toast.open({
      message:
        "<i class='fas fa-lock'></i> Verification de vos accès en cours, vous allez être rediriger sous peu",
      type: "is-success"
    });

    this.entry(document.referrer);
  },

  methods: {
    ...mapActions("auth", ["entry", "reinitialize"])
  },

  computed: {
    ...mapGetters("auth", ["referrer", "verified", "status"])
  },

  watch: {
    verified() {
      if (this.verified) {
        const location = this.referrer;
        localStorage.removeItem("referrer");
        this.reinitialize();
        document.location.href = location;
      } else if (this.status !== -1) {
        Toast.open({
          message:
            "<i class='fas fa-lock'></i> Vous devez vous ré-identifier pour confirmer votre identité.",
          type: "is-danger"
        });
        this.$router.push({ name: "Login" });
      }
    }
  }
};
</script>
